module.exports = __webpack_public_path__ + "img/1f7e188.jpg";